import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { contentfulViews } from '@glowforge/ui-common';
import { pagePropType } from 'app/common/selectors/page';
import { productPropType } from 'app/store/components/glowforge/product-selector';
import ComparisonTable from 'app/common/components/comparison-table/comparison-table';
import ComparisonTableWithImages from 'app/common/components/comparison-table-with-images/comparison-table-with-images';
import { FeaturesDisplayWidget } from 'app/common/components/features-display';
import GlowforgeProduct from './glowforge-product';
import GlowforgeProductAccordian from './glowforge-product-accordian';

import './glowforge-products-page.less';
import './product-features-list.less';

const { Page } = contentfulViews;

const ComparisonTableWrapper = props => (
  <ComparisonTable
    comparisonData={_.get(props.sections[0], 'fields')}
    callToActionText={_.get(props.textStrings[0], 'fields.text')}
    {...props} />
);

ComparisonTableWrapper.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape({
    fields: PropTypes.object,
  })).isRequired,
  textStrings: PropTypes.arrayOf(PropTypes.shape({
    fields: PropTypes.object,
  })).isRequired,
};

const GlowforgeProductsPage = ({
  page,
  productId,
  referralInfo,
  features,
  products,
}) => {
  const printerType = _.get(_.find(page.unorderedShortText, { fields: { id: `${productId}-product-name` } }), 'fields.text');
  const stringSubstitutions = [
    { name: 'printer-type', value: printerType },
  ];
  const showTitle = !_.isEmpty(productId);

  const showReferral = (
    _.get(referralInfo, 'showReferralInfo') &&
    features.REFERRAL_STRIKE_THROUGH_ON_PRODUCTS_PAGE
  );

  const glowforgeProductComponent = GlowforgeProduct;

  const customSections = {
    'glowforge-pro-section': {
      component: glowforgeProductComponent,
      props: {
        imageSectionId: 'glowforge-pro-product-description',
        buttonId: 'buy-now-pro',
        product: products.pro,
        showReferralInfo: showReferral,
        showTitle,
        showAffirm: true,
      },
    },
    'glowforge-plus-section': {
      component: glowforgeProductComponent,
      props: {
        imageSectionId: 'glowforge-plus-product-description',
        buttonId: 'buy-now-plus',
        product: products.plus,
        showReferralInfo: showReferral,
        showTitle,
        showAffirm: true,
      },
    },
    'glowforge-basic-section': {
      component: glowforgeProductComponent,
      props: {
        imageSectionId: 'glowforge-basic-product-description',
        buttonId: 'buy-now-basic',
        product: products.basic,
        showReferralInfo: showReferral,
        showTitle,
        showAffirm: true,
      },
    },
    'glowforge-whats-included-accordion': {
      component: GlowforgeProductAccordian,
    },
    'comparison-table-with-images': {
      component: ComparisonTableWithImages,
      props: {
        products,
      },
    },
    'gf-product-page-comparison-chart': {
      component: ComparisonTableWrapper,
      props: {
        products,
        showCallToAction: false,
        stringSubstitutions,
      },
    },
    'gf-products-air-filter-section': {
      component: glowforgeProductComponent,
      props: {
        imageSectionId: 'gf-af-description',
        product: products.air,
        showDeliveryDate: true,
      },
    },
    'features-display': { component: FeaturesDisplayWidget },
  };

  return (
    <Page className='GlowforgeProductsPage' {...page} customSections={customSections} stringSubstitutions={stringSubstitutions} />
  );
};

GlowforgeProductsPage.propTypes = {
  page: PropTypes.shape(pagePropType),
  products: PropTypes.objectOf(PropTypes.shape(productPropType)).isRequired,
  productId: PropTypes.string,
  referralInfo: PropTypes.shape({ showReferralInfo: PropTypes.boolean }),
  features: PropTypes.shape({
    REFERRAL_STRIKE_THROUGH_ON_PRODUCTS_PAGE: PropTypes.boolean,
  }).isRequired,
};

GlowforgeProductsPage.defaultProps = {
  page: {
    sections: [],
  },
  productId: null,
  referralInfo: { showReferralInfo: false },
};

export default GlowforgeProductsPage;



// WEBPACK FOOTER //
// ./app/components/product/glowforge-products-page.jsx